import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersMeetingNoteBookmarkType } from "~/domains";

type RequestDataType = {
  meetingNoteId: string;
};

const request = ({ meetingNoteId }: RequestDataType) => {
  return new ApiClient()
    .post<ApiMembersMeetingNoteBookmarkType>(
      `/api/members/meeting_notes/${meetingNoteId}/bookmarks`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersMeetingNotesBookmarksCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiMembersMeetingNoteBookmarkType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
